export class TagViewModel{
    name!: string;
    description!: string;
}